<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialog"
      :width="getWidth"
      :top="top"
      :before-close="handleClose"
      :append-to-body="true"
      :fullscreen="isFullScreen"
      :custom-class="!isFullScreen ? 'auto-scroll' : ''"
      :close-on-click-modal="false"
      :show-close="showClose"
    >
      <!-- <span>这是一段信息</span> -->
      <slot name="content" class="content"> </slot>
      <div slot="footer" class="dialog-footer">
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const widthMap = {
  "30%": "420px",
  "40%": "480px",
  "50%": "620px",
};
export default {
  name: "OtsCustomDialog",
  props: {
    showClose: {
      type: Boolean,
      default: true,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "提示",
    },
    width: {
      type: String,
      default: "620px",
    },
    top: {
      type: String,
      default: "15vh",
    },
    // 是否全屏弹窗
    isFullScreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    getWidth() {
      if (this.width) {
        if (widthMap[this.width]) {
          return widthMap[this.width];
        } else {
          return this.width;
        }
      } else {
        return "620px";
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-footer /deep/ .el-button--default:hover {
  background: #ecf5ff;
  color: #176de6;
  border-color: #176de6 !important;
}
/deep/ .el-dialog{
  border-radius: 8px;
  font-family: "PingFangSC-Medium, PingFang SC";
}
/deep/ .el-dialog__title {
  font-weight: 700;
}
/deep/ .el-dialog__body {
  padding: 32px;
}
/deep/ .el-dialog.auto-scroll .el-dialog__footer {
  padding-top: 0;
}
/deep/ .el-dialog .el-input {
  // width: 240px;
  height: 36px;
  line-height: 36px;
}
/deep/ .el-dialog .el-input__inner,
/deep/ .el-dialog .el-input__icon {
  height: 36px;
  line-height: 36px;
}
/deep/ .el-dialog .el-form-item__content {
  line-height: 1;
}
/deep/ .el-dialog .default-upload-container {
  width: 240px;
  height: 36px;
  line-height: 36px;
}
/deep/ .el-form-item__label {
  line-height: 1;
  padding-bottom: 16px;
}

/deep/ .el-dialog .el-pagination__sizes .el-input {
  width: 100px;
}
/deep/ .el-dialog .el-pagination__editor.el-input {
  width: 50px;
}
/deep/ .el-dialog .el-pagination__sizes .el-input__inner,
/deep/ .el-dialog .el-pagination__sizes .el-input__icon,
/deep/ .el-dialog .el-pagination__jump .el-input__inner {
  height: 28px;
  line-height: 28px;
}
/deep/ .el-radio-button__inner {
  margin-right: 16px;
  color: #45494d !important;
  background: #f4f5f8 !important;
  font-size: 13px;
  border-radius: 4px !important;
  border: 1px solid #dadde6 !important;
  padding: 10px 20px;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #ebf5ff !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
  box-shadow: none;
}
.dialog-footer /deep/ .el-button {
  width: auto;
  height: 30px;
  border-radius: 15px;
  padding: 0 23px;
  box-sizing: border-box;
}
/deep/ .el-form-item__label {
  float: none !important;
  display: block;
  text-align: left;
  padding-bottom: 8px !important;
}
/deep/ .el-dialog.is-fullscreen {
  background: #f4f5f8;
  margin-top: 60px;
  margin-bottom: 0;
  height: calc(100% - 60px);
  .el-dialog__header {
    background: #fff;
    height: 64px;
    box-sizing: border-box;
    box-shadow: 0px -1px 0px 0px #f1f2f5;
    border-radius: 8 px 8 px 0 px 0 px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    .el-dialog__headerbtn{
      top: 23px;
    }
  }
}
/deep/ .el-dialog.is-fullscreen .el-dialog__body {
  padding-top: 0 !important;
}
</style>
